import { moment } from "moment";
import { KernCAConfig } from "../../Redux/roStore";

const Gridcolumns = [
  {
    field: "VocNo",
    headerName: "Voc No",
    width: 120,
  },
  {
    field: "PostDate",
    headerName: "Post Date",
    width: 150,
  },
  {
    field: "PartyName",
    headerName: "Party Name",
    width: 300,
  },
  {
    field: "Status",
    headerName: "Status",
    width: 80,
  },
];
//Notification Summary Page
const statusData = [
  {
    id: "Pending",
    statusName: "Pending",
  },
  {
    id: "Completed",
    statusName: "Completed",
  },
  {
    id: "All",
    statusName: "All",
  },
  {
    id: "Progress",
    statusName: "Progress",
  },
];

export const GridDataSummaryColumns_Def = [
  { field: "id", headerName: "ID", width: 70, hide: true },
  { field: "VocNo", headerName: "Voc.No", width: 130 },

  { field: "TrnTyp", headerName: "TrnTyp", width: 130 },
  { field: "PartyName", headerName: "Party Name", width: 350 },
  { field: "GrnDocNo", headerName: "GrnDocNo", width: 130 },
  { field: "POLineItems", headerName: "POLineItems", width: 130, hide: true },
  { field: "INVLineItems", headerName: "Items", width: 130, hide: true },
  { field: "InvNo", headerName: "Inv.No", width: 130 },
  { field: "VirtualBinName", headerName: "Bin Name", width: 150 },

  { field: "VocTyp", headerName: "VocTyp", width: 130, hide: true },

  { field: "PDTuser", headerName: "PDTuser", width: 130, hide: true },
  {
    field: "GRNDate",
    headerName: "GRNDate",
    width: 130,
    hide: true,
    valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
  },
  { field: "GRNDocTyp", headerName: "GRNDocTyp", width: 130, hide: true },

  { field: "Party", headerName: "Party", width: 130, hide: true },
  { field: "POAmt", headerName: "POAmt", width: 130, hide: true },
  { field: "INVAmt", headerName: "INVAmt", width: 130, hide: true },
  {
    field: "InvDt",
    headerName: "InvDt",
    width: 130,
    hide: true,
    valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
  },
  { field: "Type", headerName: "Type", width: 130, hide: true },
  { field: "VirtualBinCd", headerName: "VirtualBinCd", width: 130, hide: true },
  { field: "GRNType", headerName: "GRNType", width: 130, hide: true },
  { field: "SrNo", headerName: "SrNo", width: 130, hide: true },
  {
    field: "GRNDocTypName",
    headerName: "GRNDocTypName",
    width: 130,
    hide: true,
  },
];
//PickingPending
export const GridDataPickingPendingColumns_Def = [
  { field: "id", headerName: "ID", width: 70, hide: true },
  { field: "ItmCd", headerName: "ItmCd", width: 130, hide: true },
  { field: "CardID", headerName: "Card ID", width: 130 },
  { field: "ItmName", headerName: "Item Name", width: 330 },
  { field: "F_AisleCd", headerName: "F_AisleCd", width: 130, hide: true },
  { field: "AisleName", headerName: "Aisle", width: 130 },
  { field: "F_Level", headerName: "F_Level", width: 130, hide: true },
  { field: "Level", headerName: "Level", width: 130 },
  { field: "F_BinCd", headerName: "F_BinCd", width: 130, hide: true },
  { field: "BinName", headerName: "Bin", width: 150 },
  { field: "BaseQty", headerName: "BaseQty", width: 130 },
  { field: "PickedQty", headerName: "PickedQty", width: 130 },
  { field: "BalQty", headerName: "BalQty", width: 130 },
];
//Variance
export const GridDataVarianceColumns_Def = [
  { field: "id", headerName: "ID", width: 70, hide: true },
  { field: "BinCd", headerName: "Bin Code", width: 130 },
  { field: "BinName", headerName: "Bin Name", width: 130 },
  { field: "ItmCd", headerName: "Item Code", width: 130 },
  { field: "Name1", headerName: "Name", width: 300 },
  { field: "Qty", headerName: "Qty", width: 130 },
  { field: "PkdQty", headerName: "Pkd.Qty", width: 130 },
  { field: "Diff", headerName: "Difference", width: 130 },
];
//GRIDLIST
export const GridDetailData_Def = [
  { field: "id", headerName: "ID", width: 70, hide: true },
  { field: "G_SrNo", headerName: "SrNo", width: 50 },
  { field: "G_CardID", headerName: "Card ID", width: 130 },
  { field: "ItmName", headerName: "Item Name", width: 330 },
  { field: "BinName", headerName: "Bin Name", width: 130 },
  { field: "G_Qty", headerName: "Qty", width: 50 },
  { field: "G_Unit", headerName: "Unit", width: 90, hide: true },
  { field: "UnitName", headerName: "Unit", width: 90 },

  { field: "G_VocTyp", headerName: "G_VocTyp", width: 130, hide: true },
  { field: "VocTypName", headerName: "VocTypName", width: 130, hide: true },
  { field: "G_VocNo", headerName: "G_VocNo", width: 130, hide: true },
  { field: "G_BinCd", headerName: "G_BinCd", width: 130, hide: true },
  { field: "G_ItmCd", headerName: "G_ItmCd", width: 130, hide: true },
  { field: "G_BaseQty", headerName: "G_BaseQty", width: 130, hide: true },
];

export const MultiCardFlag = () => {
  const { DBKernObj } = KernCAConfig();
  if (DBKernObj?.MULT_CARD_ID?.Val === "Y") return true;
  else return false;
};
export const WMS_PICKING_DROP_ID_Flag = () => {
  const { DBKernObj } = KernCAConfig();
  if (DBKernObj?.WMS_PICKING_DROP_ID?.Val === "Y") return true;
  else return false;
};

export { statusData, Gridcolumns };
